<template>
  <div :class="['kws-int-dropdown', { disabled: disabled, 'user-error': hasError }]" ref="dropdown">
    <div class="dropdown-toggle" :class="{active: isActive}" @click="toggle" :title="initialValue ? initialValue.name : null">
      <span v-if="!isEmpty &&  initialValue.icon" :class="['icon', initialValue.icon]"></span>
      <img v-if="!isEmpty && initialValue.image" :src="initialValue.image" alt="" />
      <div class="dropdown-input" v-text="initialValue && initialValue.name ? initialValue.name : ''"></div>
      <label v-if="isEmpty" class="dropdown-label" v-text="label"></label>
      <span class="s s-arrow-down dropdown-arrow"></span>
    </div>

    <ul class="options-box" v-if="isActive">
      <li
        class="option"
        v-if="initialValue && initialValue.name"
        @click="unset()"
      >
        <span class="icon"></span>
        <span class="name" v-text="translate('lblUnset')" :title="translate('lblUnset')"></span>
      </li>
      <li
        v-for="option in options"
        :key="option.key"
        :class="['option', option.selected ? 'selected' : null]"
        @click="select(option)"
      >
        <span v-if="!option.image" :class="['icon', option.icon]"></span>
        <img v-if="option.image" :src="option.image" alt="" />
        <span class="name" v-text="option.name" :title="option.name"></span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ImageDropdown',
  data: () => ({
    isActive: false,
  }),
  computed: {
    isEmpty() {
      return !this.initialValue || !this.initialValue.name;
    },
    disabled() {
      return !this.options || this.options.length === 0;
    },
  },
  props: {
    label: {
      type: String,
      default: 'Please select...',
    },
    initialValue: Object,
    options: Array,
    hasError: Boolean,
  },
  methods: {
    toggle() {
      if (this.isActive) {
        this.isActive = false;
      } else if (!this.disabled) {
        this.isActive = true;
      }
    },
    select(option) {
      this.isActive = false;
      this.$emit('change', option);
    },
    observeClicksOutside() {
      const handleClickOutside = (e) => {
        if (this.$refs
          && this.$refs.dropdown
          && e.target !== this.$refs.dropdown
          && !this.$refs.dropdown.contains(e.target)
        ) {
          this.isActive = false;
        }
      };
      document.body.addEventListener('click', handleClickOutside);
    },
    unset() {
      this.isActive = false;
      this.$emit('change', null);
    },
  },
  mounted() {
    this.observeClicksOutside();
  },
};
</script>

<style lang="scss">
.collect-seedpoints-form {
  .kws-int-dropdown {
    &.disabled .dropdown-toggle,
    &.disabled .dropdown-toggle label {
      cursor: not-allowed;
    }

    .dropdown-toggle .icon,
    .options-box .icon {
      margin-right: 0;
    }

    .dropdown-toggle {
      padding-left: 0;

      &::after {
        display: none;
      }
      img {
        width: rem(40px);
      }
      .dropdown-input {
        padding-left: rem(10px);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .options-box {
      padding-left: 0;
      padding-bottom: 0;
      overflow-y: scroll;
      max-height: rem(320px);

      .option {
        opacity: 1;
        padding-left: 0;
      }

      img {
        width: rem(40px);
      }

      .icon {
        flex-shrink: 0;
      }

      .name {
        padding-left: rem(12px);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}
</style>
